import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from 'react';
import { getOriginalBoundingBox } from '../../utils';
import { MOBILE_SAFE_RESIZE } from '../globalUtils';
/* const isParentOpacityAcceptable = (
  element: HTMLElement,
  opacityOffset = 0.2,
): boolean => {
  let current: HTMLElement | null = element;

  while (current && current !== document.body) {
    const computedStyle = window.getComputedStyle(current);
    const opacity = parseFloat(computedStyle.opacity);

    if (!isNaN(opacity) && opacity < opacityOffset) {
      return false;
    }

    current = current.parentElement;
  }

  return true;
}; */
const GradientWrapper = ({ active, animating, noScroll, mask, }) => {
    const wrapperRef = useRef(null);
    const activeRef = useRef(active);
    activeRef.current = active;
    const animatingRef = useRef(animating);
    animatingRef.current = animating;
    const initBurstRender = useRef(false);
    const boundsRef = useRef('');
    useEffect(() => {
        window.addEventListener(MOBILE_SAFE_RESIZE, onGradientUpdate);
        moveGradient();
        //setTimeout(() => {initBurstRender.current = false}, 1600);
        return () => {
            initBurstRender.current = false;
            window.removeEventListener(MOBILE_SAFE_RESIZE, onGradientUpdate);
        };
    }, []);
    /* useEffect(() => {
      if (active) {
        moveGradient();
      }
    }, [active]);
  */
    /* useEffect(() => {
      if (animating) {
        moveGradient();
      }
    }, [animating]); */
    const onGradientUpdate = (evt) => {
        requestAnimationFrame(moveGradient);
        /* if (evt?.detail?.resize) {
          requestAnimationFrame(moveGradient);
        } */
        /* if (noScroll && evt?.detail?.scroll) {
          return;
        }
        if (activeRef.current && !animatingRef.current) {
          requestAnimationFrame(moveGradient);
        } */
    };
    const moveGradient = () => {
        if (wrapperRef.current && wrapperRef.current.parentElement) {
            // && isParentOpacityAcceptable(wrapperRef.current)
            const bounds = getOriginalBoundingBox(wrapperRef.current.parentElement);
            if (bounds &&
                bounds.y + bounds.height > 0 &&
                bounds.y < window.innerHeight) {
                const b = `${-bounds.x}px ${-bounds.y}px`;
                if (b !== boundsRef.current) {
                    boundsRef.current = b;
                    wrapperRef.current.style.backgroundImage = 'var(--gradient)';
                    wrapperRef.current.style.backgroundPosition = b;
                }
                if (mask) {
                    wrapperRef.current.style.maskImage = mask;
                    //wrapperRef.current.style.webkitMaskImage = mask; // For Safari compatibility
                }
            }
            else {
                wrapperRef.current.style.backgroundImage = 'none';
                boundsRef.current = '';
            }
        }
        if (initBurstRender.current) {
            console.log('render');
            requestAnimationFrame(moveGradient);
        }
    };
    return _jsx("div", { className: "gradient-wrapper", ref: wrapperRef });
};
export default GradientWrapper;
